import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS } from '../../../configs/translations'

const KEYS = BUSINESS_PRIORITIES_TRANSLATION_KEYS

interface ISwitchConfirmationDialogProps {
  isVisible: boolean
  actionType: 'on' | 'off'
  onConfirm: () => void
  onReject: () => void
}

export const SwitchConfirmationDialog: FC<ISwitchConfirmationDialogProps> = ({
  isVisible,
  actionType,
  onConfirm,
  onReject,
}) => (
  <ConfirmationDialog
    isVisible={isVisible}
    title={KEYS.switchConfirmDialog.title}
    confirmBtnText={KEYS.switchConfirmDialog.confirm}
    rejectBtnText={KEYS.switchConfirmDialog.cancel}
    onConfirm={onConfirm}
    onReject={onReject}
    content={
      <>
        <Translation
          text={
            actionType === 'off'
              ? KEYS.switchConfirmDialog.messageSwitchOff
              : KEYS.switchConfirmDialog.messageSwitchOn
          }
        />
        <Translation text={KEYS.switchConfirmDialog.wwLeadWarning} />
      </>
    }
  />
)

SwitchConfirmationDialog.displayName = 'SwitchConfirmationDialog'
